import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



	
	const __default__ = { name: 'VBadge' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		color: {
			type: String,
			default: 'zinc'
		},
		outline: {
			type: Boolean,
			default: false
		},
		pill: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

	const styles: {[ k: string ]: any} = {
		outline: [
			// Base
			'border border-zinc-950/10 text-zinc-950',
			// Dark mode
			'dark:border-white/15 dark:text-white'
		],
		dot: {
			red: '[&>[data-slot=dot]]:text-red-500 [&>[data-slot=dot]]:dark:text-red-400',
			orange: '[&>[data-slot=dot]]:text-orange-500 [&>[data-slot=dot]]:dark:text-orange-400',
			amber: '[&>[data-slot=dot]]:text-amber-500 [&>[data-slot=dot]]:dark:text-amber-400',
			yellow: '[&>[data-slot=dot]]:text-yellow-500 [&>[data-slot=dot]]:dark:text-yellow-300',
			lime: '[&>[data-slot=dot]]:text-lime-500 [&>[data-slot=dot]]:dark:text-lime-300',
			green: '[&>[data-slot=dot]]:text-green-500 [&>[data-slot=dot]]:dark:text-green-400',
			emerald: '[&>[data-slot=dot]]:text-emerald-500 [&>[data-slot=dot]]:dark:text-emerald-400',
			teal: '[&>[data-slot=dot]]:text-teal-500 [&>[data-slot=dot]]:dark:text-teal-300',
			cyan: '[&>[data-slot=dot]]:text-cyan-500 [&>[data-slot=dot]]:dark:text-cyan-300',
			sky: '[&>[data-slot=dot]]:text-sky-500 [&>[data-slot=dot]]:dark:text-sky-300',
			blue: '[&>[data-slot=dot]]:text-blue-500 [&>[data-slot=dot]]:dark:text-blue-400',
			indigo: '[&>[data-slot=dot]]:text-indigo-500 [&>[data-slot=dot]]:dark:text-indigo-400',
			violet: '[&>[data-slot=dot]]:text-violet-500 [&>[data-slot=dot]]:dark:text-violet-400',
			purple: '[&>[data-slot=dot]]:text-purple-500 [&>[data-slot=dot]]:dark:text-purple-400',
			fuchsia: '[&>[data-slot=dot]]:text-fuchsia-500 [&>[data-slot=dot]]:dark:text-fuchsia-400',
			pink: '[&>[data-slot=dot]]:text-pink-500 [&>[data-slot=dot]]:dark:text-pink-400',
			rose: '[&>[data-slot=dot]]:text-rose-500 [&>[data-slot=dot]]:dark:text-rose-400',
			zinc: '[&>[data-slot=dot]]:text-zinc-500 [&>[data-slot=dot]]:dark:text-zinc-400'
		},
		colors: {
			red: 'bg-red-500/15 text-red-700 group-data-[hover]:bg-red-500/25 dark:bg-red-500/10 dark:text-red-400 dark:group-data-[hover]:bg-red-500/20',
			orange: 'bg-orange-500/15 text-orange-700 group-data-[hover]:bg-orange-500/25 dark:bg-orange-500/10 dark:text-orange-400 dark:group-data-[hover]:bg-orange-500/20',
			amber: 'bg-amber-400/20 text-amber-700 group-data-[hover]:bg-amber-400/30 dark:bg-amber-400/10 dark:text-amber-400 dark:group-data-[hover]:bg-amber-400/15',
			yellow: 'bg-yellow-400/20 text-yellow-700 group-data-[hover]:bg-yellow-400/30 dark:bg-yellow-400/10 dark:text-yellow-300 dark:group-data-[hover]:bg-yellow-400/15',
			lime: 'bg-lime-400/20 text-lime-700 group-data-[hover]:bg-red-400/30 dark:bg-lime-400/10 dark:text-lime-300 dark:group-data-[hover]:bg-lime-400/15',
			green: 'bg-green-500/15 text-green-700 group-data-[hover]:bg-green-500/25 dark:bg-green-500/10 dark:text-green-400 dark:group-data-[hover]:bg-green-500/20',
			emerald: 'bg-emerald-500/15 text-emerald-700 group-data-[hover]:bg-emerald-500/25 dark:bg-emerald-500/10 dark:text-emerald-400 dark:group-data-[hover]:bg-emerald-500/20',
			teal: 'bg-teal-500/15 text-teal-700 group-data-[hover]:bg-teal-500/25 dark:bg-teal-500/10 dark:text-teal-300 dark:group-data-[hover]:bg-teal-500/20',
			cyan: 'bg-cyan-400/20 text-cyan-700 group-data-[hover]:bg-cyan-400/30 dark:bg-cyan-400/10 dark:text-cyan-300 dark:group-data-[hover]:bg-cyan-400/15',
			sky: 'bg-sky-500/15 text-sky-700 group-data-[hover]:bg-sky-500/25 dark:bg-sky-500/10 dark:text-sky-300 dark:group-data-[hover]:bg-sky-500/20',
			blue: 'bg-blue-500/15 text-blue-700 group-data-[hover]:bg-blue-500/25 dark:text-blue-400 dark:group-data-[hover]:bg-blue-500/25',
			indigo: 'bg-indigo-500/15 text-indigo-700 group-data-[hover]:bg-indigo-500/25 dark:text-indigo-400 dark:group-data-[hover]:bg-indigo-500/20',
			violet: 'bg-violet-500/15 text-violet-700 group-data-[hover]:bg-violet-500/25 dark:text-violet-400 dark:group-data-[hover]:bg-violet-500/20',
			purple: 'bg-purple-500/15 text-purple-700 group-data-[hover]:bg-purple-500/25 dark:text-purple-400 dark:group-data-[hover]:bg-purple-500/20',
			fuchsia: 'bg-fuchsia-400/15 text-fuchsia-700 group-data-[hover]:bg-fuchsia-400/25 dark:bg-fuchsia-400/10 dark:text-fuchsia-400 dark:group-data-[hover]:bg-fuchsia-400/20',
			pink: 'bg-pink-400/15 text-pink-700 group-data-[hover]:bg-pink-400/25 dark:bg-pink-400/10 dark:text-pink-400 dark:group-data-[hover]:bg-pink-400/20',
			rose: 'bg-rose-400/15 text-rose-700 group-data-[hover]:bg-rose-400/25 dark:bg-rose-400/10 dark:text-rose-400 dark:group-data-[hover]:bg-rose-400/20',
			zinc: 'bg-zinc-600/10 text-zinc-700 group-data-[hover]:bg-zinc-600/20 dark:bg-white/5 dark:text-zinc-400 dark:group-data-[hover]:bg-white/10',
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
			'inline-flex items-center gap-x-1.5 px-1.5 py-0.5 text-sm/5 font-medium sm:text-xs/5 forced-colors:outline',
			'bg-blend-multiply dark:bg-blend-screen bg-gradient-to-t from-white to-white dark:from-gray-900 dark:to-gray-900',
			props.pill ? 'rounded-full px-2' : 'rounded-md',
			styles.dot[props.color],
			props.outline ? styles.outline : styles.colors[props.color]
		])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})